import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./WhyChooseUs.css";

gsap.registerPlugin(ScrollTrigger);

const WhyChooseUs = () => {
  const sectionRef = useRef(null);
  const cardRef = useRef(null);

  useEffect(() => {
    // Entrance animation
    gsap.from(cardRef.current, {
      opacity: 0,
      y: 80,
      scale: 0.95,
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 80%",
      },
    });

    // Looping pulse animation
    gsap.to(cardRef.current, {
      scale: 1.015,
      duration: 2,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
      delay: 1.5,
    });
  }, []);

  return (
   <section class="cta-section">
  <div class="cta-overlay"></div>

  <div class="cta-card">
    <h2>Why Choose Us</h2>
    <h1>Build Something Powerful</h1>
    <p>
      We create high-performance digital experiences that help brands
      grow faster and stand out.
    </p>

   <a 
  href="https://wa.me/917217647341" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <button class="cta-btn">Get Started</button>
</a>
  </div>
</section>
  );
};

export default WhyChooseUs;
